export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <img
          src="/qualive-logo.png"
          alt="QUALIVE"
          data-testid="footer-brand-title"
          className="w-full max-w-5xl h-auto select-none"
        />

        <div
          data-testid="footer-links"
          className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-6"
        >
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {[
              { label: "Formula One", href: "#formula-one" },
              { label: "Football", href: "#football" },
              { label: "What We Do", href: "#services" },
              { label: "Global", href: "#global" },
              { label: "About", href: "#about" },
              { label: "Contact", href: "#contact" },
            ].map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="font-mono-tech text-[11px] uppercase tracking-[0.2em] text-neutral-500 hover:text-[#F7F6F2] transition-colors duration-200"
              >
                {l.label}
              </a>
            ))}
          </nav>
          <a
            href="mailto:partnerships@qualive.co.uk"
            className="font-mono-tech text-[11px] uppercase tracking-[0.2em] text-neutral-400 hover:text-[#F7F6F2] transition-colors duration-200"
          >
            partnerships@qualive.co.uk
          </a>
        </div>

        <p
          data-testid="footer-copyright"
          className="mt-8 font-mono-tech text-[10px] uppercase tracking-[0.2em] text-neutral-600"
        >
          © {new Date().getFullYear()} QUALIVE Ltd — Founded 2023 · Sports Partnerships · Formula One · Football
        </p>
      </div>
    </footer>
  );
}
